import React from "react";
import RunTabContent, { type RunTabBaseProps } from "./RunTabContent";

const ViewRunsTab: React.FC<RunTabBaseProps> = (props) => {
  return <RunTabContent {...props} tabIndex={0} />;
};

export default ViewRunsTab;
